import React, {PureComponent} from "react";
import {injectIntl} from "react-intl";
import Confirm from "./Confirm";

let activeDialog = null;

/**
 * Asks whether the visitor is the customer a personal link belongs to. Resolves true on "yes" only -
 * "no", the backdrop and escape all resolve false, so a dismissed dialog never passes for a "yes".
 * With no dialog mounted there is no one to ask, and nothing is assumed: it resolves false.
 */
export const askIdentityConfirmation = (fullName) => {
    if (!activeDialog) {
        return Promise.resolve(false);
    }

    return activeDialog.ask(fullName);
};

class IdentityConfirmationDialog extends PureComponent {
    componentDidMount() {
        activeDialog = this;
    }

    componentWillUnmount() {
        if (activeDialog === this) {
            activeDialog = null;
        }
    }

    ask(fullName) {
        const {intl} = this.props;
        return new Promise((resolve) => {
            this.dialog.show(
                intl.formatMessage({id: 'identity.confirmTitle'}),
                intl.formatMessage({id: 'identity.confirmBody'}, {fullName: fullName || ''}),
                (confirmed) => resolve(confirmed === true)
            );
        });
    }

    render() {
        const ltr = !this.props.intl.locale.includes('he');
        return <Confirm ref={dialog => this.dialog = dialog} ltr={ltr}
                        cancelMessageId="identity.notMe" confirmMessageId="identity.itsMe"/>;
    }
}

export default injectIntl(IdentityConfirmationDialog);
